module.exports = __webpack_public_path__ + "img/Menu-10.63cae7f0.webp";